// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
// roter
import router from './router'
// vuex
import store from './store'
// APP
import App from './App'

// MuseUI
import MuseUI from 'muse-ui'
import 'muse-ui/dist/muse-ui.css'
import 'muse-ui/dist/theme-light.min.css'
// ElementUI
import ElementUI from 'element-ui'
import '@/scss/element.scss'

import '@/scss/tailwind.css'

// MuseUI
Vue.use(MuseUI)
// ElementUI
Vue.use(ElementUI)

// html5Editor
// Vue.use(VueHtml5Editor, h5config);

// 过滤器
import './filters'
// 组件
import './components'

Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
